import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-83" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-84" data-mp="23x4lypi7100n">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-teal sm:text-xs" data-id="element-85" data-mp="30k984mvrs3n6">
          EL PACK COMPLETO DE MÚSICA LISTA
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-blue sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-86" data-mp="2rt0ji3zio31w">
          Enseñá un Año Completo de <span className="italic text-brand-orange" data-id="element-87" data-mp="3fh9x4imktkhy">Música</span> en Solo
          5 Minutos de Preparación
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-88" data-mp="2ffiarq9wx1og">
          Música Lista es la colección completa de docencia musical: teoría, actividades, ejercicios
          y recursos 100% listos, para que prepares tus clases sin esfuerzo, todo el año.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/sRz5ckf8rem9y5Ji1B99BS/ChatGPT_Image_30_jul_2026,_09_59_54-Photoroom.png" alt="Los 12 tomos de Música Lista de Primaria y Secundaria, los 5 bonos, instrumentos y recursos digitales" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-89" data-mp="2kev8j62bnt5t" />
        <div className="flex w-full flex-col items-center" data-id="element-90" data-mp="381tm9vz24n01">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-91" data-mp="336e7n1t86n2k">
            QUIERO EL PACK MÚSICA LISTA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-92" data-mp="18sdd2t4pkm8a">
            ✓ Acceso inmediato <span className="px-1 text-brand-orange" data-id="element-93" data-mp="38vo0ut01npcn">·</span> ✓ Garantía de 7 días
          </p>
        </div>
      </motion.div>
    </section>;
}